import { ActionIcon, Tooltip, type ActionIconProps } from '@mantine/core';
import { notify } from '@/lib/notify';
import { IconCopy } from '@tabler/icons-react';

export interface CopyMeetingLinkButtonProps {
  link?: string;
  size?: ActionIconProps['size'];
  variant?: ActionIconProps['variant'];
  color?: ActionIconProps['color'];
}

export function CopyMeetingLinkButton({
  link,
  size = 'lg',
  variant = 'light',
  color = 'gold',
}: CopyMeetingLinkButtonProps): JSX.Element | null {
  const trimmed = link?.trim();
  if (!trimmed) return null;

  const copyLink = (): void => {
    if (!navigator.clipboard?.writeText) {
      notify({
        title: 'Copy failed',
        message: 'Clipboard is not available in this context.',
        type: 'error',
      });
      return;
    }
    void navigator.clipboard.writeText(trimmed).then(
      () => {
        notify({
          title: 'Link copied',
          message: 'Meeting link copied to clipboard.',
          type: 'success',
        });
      },
      () => {
        notify({
          title: 'Copy failed',
          message: 'Could not copy meeting link.',
          type: 'error',
        });
      },
    );
  };

  return (
    <Tooltip label="Copy meeting link">
      <ActionIcon size={size} variant={variant} color={color} onClick={copyLink}>
        <IconCopy size={size === 'sm' ? 14 : size === 'md' ? 16 : 20} />
      </ActionIcon>
    </Tooltip>
  );
}
